import React from 'react';
import { compose, withProps, onlyUpdateForKeys } from 'recompose';
import { connect } from 'react-redux';
import styled, { StylesProps } from '../../../lib/styles';
import { callOnMount } from '../../../behaviour/patterns';
import Spacer from '../../../components/presentational/Spacer';
import HolidaysBlock from '../../../components/presentational/HolidaysBlock';
import { actions } from '../store';
import memoize from '../../../lib/selectorUtils';
import { holidaysUrlSelector, holidaysSelector } from '../store/selectors';
import { SHOW_MORE_HOLIDAYS, RECIRCULATED_HOLIDAY_CLICKED } from '../lib/ga';
import { trackEvent } from '../../../lib/ga';
import { Holiday } from '../../../models/holiday';
import articleHolidaysStyles from './ArticleHolidays_styles';

export interface ArticleHolidaysProps {
  holidays: Holiday[];
  url?: string;
}

const ArticleHolidays = ({
  holidays,
  styles,
}: ArticleHolidaysProps & StylesProps<typeof articleHolidaysStyles>) => (
  <>
    {holidays.length > 0 && (
      <Spacer
        selfH={['xs', 's']}
        selfT={'l'}
        align={'center'}
        maxWidth={1600}
        className={styles.section}
      >
        <Spacer>
          <HolidaysBlock
            holidays={holidays}
            title={'Book your next holiday'}
            hasMore
            lazy={true}
            onClick={({ slug }) =>
              trackEvent(
                { ...RECIRCULATED_HOLIDAY_CLICKED, label: slug },
                { transport: 'beacon' }
              )
            }
            onShowMore={() => {
              window.open('//travelat60.com', '_blank');
              trackEvent(SHOW_MORE_HOLIDAYS, {
                transport: 'beacon',
              });
            }}
          />
        </Spacer>
      </Spacer>
    )}
  </>
);

const articleHolidaysProps = memoize(
  holidaysSelector,
  holidaysUrlSelector,
  (holidays, url) => ({ holidays, url })
);

const dispatchProps = dispatch => ({
  loadHolidays: url => dispatch(actions.loadHolidays(url)),
});

export default compose(
  connect(articleHolidaysProps, dispatchProps),
  withProps(({ url, loadHolidays }) => ({
    onMount() {
      if (url) loadHolidays(url);
    },
  })),
  callOnMount('onMount'),
  styled(articleHolidaysStyles),
  onlyUpdateForKeys(['holidays'])
)(ArticleHolidays);
